import { IContractFormikStatus } from 'services/templates/types';
import { contractTemplateFormInitialStatus } from '../form/contractTemplateFormInitialStatus';

export const distributionTemplateInitialStatus: IContractFormikStatus = {
  ...contractTemplateFormInitialStatus,
};
